module.exports = __webpack_public_path__ + "img/elva_avatar.60f7c11f.png";